import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { Post } from "./Post";
import { api } from "configs";
import { IMensagem } from "@deltasge/marauders-map";

export const Timeline: React.FC = () => {
  const [posts, setPosts] = useState<IMensagem[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get<[IMensagem[], number]>("/novidades/6");
        setPosts(data[0]);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    })();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        {posts.map((post) => (
          <Post key={post.id} post={post} />
        ))}
      </Box>
    </Container>
  );
};
